export default {
  ActivityLogImportJob: 'Импорт журнала активности',
  AllSurveysDataMigrationJob: 'Миграция данных всех опросов',
  ArenaMobileDataImportJob: 'Импорт данных Arena',
  ArenaMobileDataImportSummaryJob: 'Сводка импорта данных Arena',
  CategoriesImportJob: 'Импорт категорий',
  CategoriesValidationJob: 'Валидация категорий',
  CategoriesBatchImportJob: 'Импорт категорий',
  CategoryImportJob: 'Импорт категории',
  CategoryImportInternalJob: 'Импорт категории',
  CategoryBatchImportJob: 'Импорт категории',
  CategoryValidationJob: 'Валидация категории',
  ChainsSamplingNodeDefsCheckJob: 'Обработка создания определений узлов выборки цепочек',
  ChainsValidationJob: 'Валидация цепочек обработки',
  ChainsImportJob: 'Импорт цепочек',
  CollectDataImportJob: 'Импорт данных Collect',
  CollectImportJob: 'Импорт Collect',
  CollectSurveyReaderJob: 'Чтение опроса Collect',
  CyclesDeletedCheckJob: 'Проверка удаленных циклов',
  DataDeleteJob: 'Удаление данных',
  DataImportJob: 'Импорт данных',
  DataImportValidationJob: 'Валидация файла импорта данных',
  EntitiesDeleteJob: 'Удаление существующих объектов',
  FilesImportJob: 'Импорт файлов',
  MessageSendJob: 'Отправка сообщения',
  NodeDefsTranslationJob: 'Перевод меток определений узлов',
  NodeDefsImportJob: 'Импорт определений узлов',
  NodeDefsValidationJob: 'Валидация определений узлов',
  chainsCyclesCheckJob: 'Проверка циклов цепочек',
  RecordCheckJob: 'Проверка записи',
  RecordsCloneJob: 'Клонирование записей',
  RecordsImportJob: 'Импорт записей',
  RecordsUniquenessValidationJob: 'Валидация уникальности записей',
  SamplingPointDataImportJob: 'Импорт данных точек отбора проб',
  SchemaSummaryExportJob: 'Экспорт сводки схемы',
  SurveyActivityLogClearJob: 'Очистка журнала активности опроса',
  SurveyCreatorJob: 'Создание опроса',
  SurveyDependencyGraphsGenerationJob: 'Генерация графов зависимостей опроса',
  SurveyExportJob: 'Экспорт опроса',
  SurveyFilesImportJob: 'Импорт файлов опроса',
  SurveyIndexGeneratorJob: 'Генератор индекса опроса',
  SurveyInfoValidationJob: 'Валидация информации об опросе',
  SurveyLabelsImportJob: 'Импорт меток опроса',
  SurveyPropsPublishJob: 'Публикация свойств опроса',
  SurveyPublishJob: 'Публикация опроса',
  SurveyPublishPerformJob: 'Выполнение публикации опроса',
  SurveyRdbCreationJob: 'Создание RDB опроса',
  SurveyUnpublishJob: 'Отмена публикации опроса',
  SurveyPropsUnpublishJob: 'Отмена публикации свойств опроса',
  SurveysListExportJob: 'Экспорт списка опросов',
  TaxonomiesImportJob: 'Импорт таксономий',
  TaxonomiesValidationJob: 'Валидация таксономий',
  TaxonomyImportJob: 'Импорт таксономии',
  // data export
  ArenaFileReadJob: 'Чтение файла Arena',
  DataExportJob: 'Экспорт данных',
  DataSummaryExportJob: 'Экспорт сводных данных',
  ZipCreationJob: 'Создание ZIP-файла',
  CSVDataExtraction: 'Извлечение данных',
  PrepareImportFileJob: 'Подготовка файла импорта',
  // geo
  GeoJsonDataExportJob: 'Экспорт данных GeoJson',
  // import arena survey
  ArenaImportJob: 'Импорт Arena',
  ArenaSurveyReaderJob: 'Чтение опроса Arena',
  CreateRdbJob: 'Создание RDB опроса',
  UsersImportJob: 'Импорт пользователей',
  // clone survey
  SurveyCloneJob: 'Клонировать опрос',
  CloneSurveyJob: 'Клонировать опрос',
  // survey backup
  SurveyInfoExportJob: 'Экспорт информации об опросе',
  CategoriesExportJob: 'Экспорт категорий',
  TaxonomiesExportJob: 'Экспорт таксономий',
  RecordsExportJob: 'Экспорт записей',
  RecordFilesExportJob: 'Экспорт файлов записей',
  SurveyFilesExportJob: 'Экспорт файлов опроса',
  ChainExportJob: 'Экспорт цепочки',
  UsersExportJob: 'Экспорт пользователей',
  ActivityLogExportJob: 'Экспорт журнала активности',
  InfoExportJob: 'Формирование информации о выходном файле',
  // validation report
  VaidationReportGenerationJob: 'Сформировать отчет о проверке',
  // record validation
  RecordsValidationJob: 'Проверка записей',
  // analysis
  PersistResultsJob: 'Сохранение результатов анализа',
  elapsed: 'Прошедшее время',
  remaining: 'Оставшееся время',
}
